import { render, staticRenderFns } from "./SalaryStructure.vue?vue&type=template&id=d69ecd24&scoped=true&"
import script from "./SalaryStructure.vue?vue&type=script&lang=js&"
export * from "./SalaryStructure.vue?vue&type=script&lang=js&"
import style0 from "./SalaryStructure.vue?vue&type=style&index=0&id=d69ecd24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69ecd24",
  null
  
)

export default component.exports